<template lang='pug'>
#section3
	#section3-anchor
	.content-section
		.header
			h2 Verðlisti
			img.underline(src='@/assets/blue_wave.svg')
		.paragraph
			p.red 1. Júní - almenn miðasala hefst
			p Helgarpassi: 18.990kr
			p Laugardagspassi: 15.990kr
			p Föstudagsball: 6.990kr
			p Laugardagsball: 7.990kr
			p Fös og Lau ball: 13.990kr

		.button(@click='changeNav("section4-anchor")') Miðakaup

	.image-section
		img.pattern(src='@/assets/circle_waves.svg')
		img.image(src='@/assets/images/group.png')
	img.pattern-mobile(src='@/assets/circle_waves.svg')
</template>

<script>
export default {
	name: 'Section3',
	methods: {
		changeNav: function (target) {
			this.$SmoothScroll(document.getElementById(target), 700, null, null, 'y');
			this.nav = false;
		},
		openLink: function (target) {
			window.open(target, '_blank').focus();
		}
	}
};
</script>

<style lang="less" scoped>
#section3 {
	#section3-anchor {
		width: 100vw;
		height: 5px;
		position: absolute;
		top: -150px;
	}
	position: relative;
	margin-top: 80px;
	padding-left: 117px;
	display: grid;
	grid-template-columns: 1fr 1fr;
	@media screen and (max-width: 1439px) {
		grid-template-columns: 1fr;
		margin-top: 0px;
		padding-left: 0px;
	}
	.pattern-mobile {
		visibility: hidden;
		height: 0px;
	}
	.image-section {
		transform: translateY(-100px);
		@media screen and (max-width: 1439px) {
			transform: translateY(0px);
			margin-left: auto;
			margin-right: auto;
		}
		position: relative;
		.pattern {
			transform: translateY(-310px);
			position: absolute;
			right: 0px;
			z-index: 1;
			@media screen and (max-width: 1439px) {
				visibility: hidden;
			}
		}
		.image {
			transform: translateX(76px);
			@media screen and (max-width: 1439px) {
				transform: translateX(0px);
			}
			position: relative;
			z-index: 2;
      max-width: 640px;
      margin-top: 100px;
		}
	}
	.content-section {
		@media screen and (max-width: 1439px) {
			position: relative;
			margin-left: auto;
			margin-right: auto;
		}
		@media screen and (max-width: 475px) {
			padding-left: 30px;
			padding-right: 30px;
		}
		.header {
      @media screen and (min-width: 1439px) {
        margin-top: -45px;
      }
			h2 {
				z-index: 2;
				position: relative;
				font-size: 40px;
				color: #f3736b;
				font-weight: bold;
				@media screen and (max-width: 870px) {
					font-size: 31px;
				}
			}
			.underline {
				z-index: 2;
				position: relative;
				transform: translateY(-20px);
			}
		}
		.paragraph {
			p {
				position: relative;
				transform: translateY(-10px);
				margin-top: 0px;
				max-width: 426px;
				line-height: 1.94;
				font-size: 18px;
				margin-left: 78px;
				z-index: 2;
				@media screen and (min-width: 1440px) {
					max-width: 626px;
				}
				@media screen and (max-width: 530px) {
					margin-left: 0px;
					font-size: 16px;
				}
			}
      .red {
        color: #F3736B;
      }
		}
    .button {
      margin-left: 78px;
      width: 158px;
      height: 48px;
      border-radius: 24px;
      border: solid 2px #118acd;
      line-height: 48px;
      text-align: center;
      font-size: 21px;
      font-weight: bold;
      transition: .5s;
      cursor: pointer;
      background: url('~@/assets/top.svg');
      background-size: 177px 101px;
      background-position-y: -100px;
      background-repeat: no-repeat;
      margin-bottom: 48px;
      &:hover {
        color: white;
        background-position-y: 0px;
      }
      @media screen and (max-width: 530px) {
        margin-left: auto;
        margin-right: auto;
      }
    }
	}
	@media screen and (max-width: 1439px) {
		.pattern-mobile {
			visibility: initial;
			position: absolute;
			right: 0px;
			height: auto;
			z-index: 1;
		}
	}
}
</style>
